import type { Theme } from "@mui/material/styles";
import { FORM_CONTROL_MIN_HEIGHT } from "../tokens";
import type { AppIngestPageStyles } from "../types";

export function buildIngestPageStyles(theme: Theme): AppIngestPageStyles {
  return {
    uploadPanel: {
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      alignItems: { xs: "stretch", md: "center" },
      gap: 1.5,
      p: 1.5,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      bgcolor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.03)" : "grey.50",
    },
    fileButton: {
      flexShrink: 0,
      minHeight: FORM_CONTROL_MIN_HEIGHT,
      alignSelf: { xs: "stretch", md: "flex-start" },
    },
    fileInfoStack: { flex: 1, minWidth: 0, px: { md: 0.5 } },
    uploadButton: {
      flexShrink: 0,
      minHeight: FORM_CONTROL_MIN_HEIGHT,
      minWidth: { xs: "100%", md: 168 },
    },
  };
}
